import React from "react";
import { ReduxConnect } from "../../../toolkit/decorators/Artifact";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import PrecalculoPage from "../../components/precalculo";
import {
  PrecalculoDispatcher,
  precalculoDispatcher
} from "./Precalculo.dispatcher";
import { precalculoStore, PrecalculoStore } from "./Precalculo.store";

interface Props extends PrecalculoStore, PrecalculoDispatcher {}
interface State {}

@ReduxConnect(precalculoStore, precalculoDispatcher)
export default class Precalculo extends React.Component<Props, State> {
  render() {
    return (
      <main>
        <Helmet title="Reportes de Precálculo" />
        <Layout>
          <PrecalculoPage {...this.props} />
        </Layout>
      </main>
    );
  }
}
